import CommonConstant from '../constants/common.constant';
import { sanitizeForLog } from './logSanitizer';

const ConsoleLog = (message: string | object, data?: string) => {
  if (process.env.ENVIRONMENT === CommonConstant.localEnvironemt) {
    const sanitizedMessage = sanitizeForLog(String(message));
    const sanitizedData = data ? sanitizeForLog(data) : '';
    console.log(`${sanitizedMessage}${sanitizedData ? ' ' + sanitizedData : ''}`);
  }
};

const ConsoleLogError = (message: any, data?: string) => {
  if (`${process.env.ENVIRONMENT}` == CommonConstant.localEnvironemt) {
    if (data) console.error(message, data);
    else console.error(message, data);
  }
};

const getDeviceName = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'TAB';
  } else if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
  ) {
    return 'MOBILE';
  } else {
    return 'PC';
  }
};

const formatString = (format: string, ...args: any[]): string => {
  return format.replace(/{(\d+)}/g, (match, index) => {
    const argIndex = parseInt(index, 10);
    return args[argIndex] !== undefined ? args[argIndex].toString() : match;
  });
};

const isFormFieldInvalid = (name: any, form: any) => !!(form.touched[name] && form.errors[name]);

const getFormErrorMessage = (name: any, form: any) => {
  return isFormFieldInvalid(name, form)
    ? '<small className="p-error">' + (form.errors[name] as string) + '</small>'
    : '<small className="p-error">&nbsp;</small>';
};

const getNext7Days = () => {
  const today = new Date();
  let next7Days = '';

  const nextDay = new Date(today);
  nextDay.setDate(today.getDate() + 7);
  next7Days = nextDay.toDateString();

  return next7Days;
};

const getNext7DaysByDate = (date: Date) => {
  let next7Days = '';

  const nextDay = new Date(date);
  nextDay.setDate(date.getDate() + 7);
  next7Days = nextDay.toDateString();

  return next7Days;
};

const formatAmountInINR = (amount: number) => {
  const formattedAmount = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
  }).format(amount);

  return formattedAmount;
};

const toSentenceCase = (str: string): string => {
  if (!str || typeof str !== 'string') return '';

  const words = str.trim().split(/\s+/);

  // Helper function to detect if a word is likely an abbreviation/acronym
  const isAbbreviation = (word: string): boolean => {
    // Check if word is all uppercase and 2-5 characters (common abbreviations)
    if (word.length >= 2 && word.length <= 5 && word === word.toUpperCase()) {
      return true;
    }
    // Check if word has multiple uppercase letters with no lowercase (like "VDF", "POC")
    if (word.length >= 2 && /^[A-Z]+$/.test(word)) {
      return true;
    }
    return false;
  };

  for (let i = 0; i < words.length; i++) {
    if (i === 0) {
      // First word: if it's an abbreviation, keep it; otherwise capitalize first letter
      if (isAbbreviation(words[i])) {
        // Keep abbreviation as is
      } else {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
      }
    } else {
      // Other words: if it's an abbreviation, keep it; otherwise lowercase
      if (!isAbbreviation(words[i])) {
        words[i] = words[i].toLowerCase();
      }
    }
  }

  return words.join(' ');
};

const Helpers = {
  ConsoleLog,
  ConsoleLogError,
  getDeviceName,
  getNext7Days,
  formatString,
  formatAmountInINR,
  getFormErrorMessage,
  getNext7DaysByDate,
  toSentenceCase,
};

export default Helpers;

// Helper: Rounding Value
export const formatNumber = (value: any, decimals = 0) => {
  if (value === null || value === undefined || isNaN(value)) return '';
  return Number(value).toFixed(decimals);
};
